import * as IconSelector from '../icons';

// Constantes exportadas
export const LOCK_PARCEL_COSECHA_EN_VERDE = 'Cosecha en Verde';
export const LOCK_PARCEL_EXCESO_RENDIMIENTO = 'Exceso Rendimiento';

// Definición del enum
export const locksParcel = [
    {
        value: null,
        label: 'Sin definir',
        description: 'No se ha definido un bloqueo',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: LOCK_PARCEL_COSECHA_EN_VERDE,
        label: 'Cosecha en Verde',
        description: 'Se ha bloqueado porque ha realizado consecha en verde',
        icon: IconSelector.RecolectionIcon,
        color: 'red'
    },
    {
        value: LOCK_PARCEL_EXCESO_RENDIMIENTO,
        label: 'Exceso Rendimiento',
        description: 'Se ha bloqueado porque tiene exceso de rendimiento',
        icon: IconSelector.ExceedIcon,
        color: 'DarkRed'
    }
];
